// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.ticket {
  transition: all 0.4s ease-in-out;
}
.ticket:hover {
  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.15);
}

.ticket-row {
  border-color:#edeff1;
  border-style: dashed;
  border:1px dashed #edeff1;
  transition: all 0.2s ease-in-out;
  vertical-align: center;

}

.w-300 {
  width: 300px;
}
.info h3 {
  padding: 8px 15px;
}
.table-action-button {
  color: #fff;
  padding: 6px 16px;
  border-radius: 24px;
  font-size: 12px;
}
.m-5 {
  margin: 5px;
}
.p0 {
  padding: 0;
}
.pointer {
  cursor: pointer;
}
.products {
  padding: 15px;
  max-width: 20%;
}
.products .row {
  height: 80px;
  margin-bottom: 15px;
  display: flex;
  align-items: stretch;
  background-color: #fff;
  border-radius: 15px;
}
.products .row .image {
  width: 120px;
  height: 80px;
  padding: 5px;
  display: flex;
  align-items: center;
}
.products .row .image img {
  width: 100%;
}
.products .row .type {
  display: flex;
  align-items: center;
  flex-grow: 2;
  justify-content: center;
  padding: 15px;
  border-left: #ddd solid 1px;
}
.products .row .account {
  display: flex;
  flex-grow: 3;
  flex-direction: column;
  justify-content: center;
  padding: 15px;
  border-left: #ddd solid 1px;
}
.app_customer_layout {
  padding: 15px 20px;
}
.form_group_modal {
  width: 100%;
}
.form_group_modal textarea {
  width: 100%;
}
.image-modal {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  cursor: pointer;
}
.image-modal img {
  width: 100%;
  height: auto;
}
.image-modal p {
  font-size: 14px;
  background-color: #fff;
  border-radius: 6px;
  margin-bottom: 10px;
  color: #3091b2;
  padding: 10px 20px;
}


/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/containers/ticketing/components/system-fields-directives/repossession-ticket-view-directive/repossession-ticket-view-directive.css"],"names":[],"mappings":";AACA;EACE,gCAAgC;AAClC;AACA;EACE,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,yBAAyB;EACzB,gCAAgC;EAChC,sBAAsB;;AAExB;;AAEA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;;AAGA,ggIAAggI","sourcesContent":["\n.ticket {\n  transition: all 0.4s ease-in-out;\n}\n.ticket:hover {\n  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.15);\n}\n\n.ticket-row {\n  border-color:#edeff1;\n  border-style: dashed;\n  border:1px dashed #edeff1;\n  transition: all 0.2s ease-in-out;\n  vertical-align: center;\n\n}\n\n.w-300 {\n  width: 300px;\n}\n.info h3 {\n  padding: 8px 15px;\n}\n.table-action-button {\n  color: #fff;\n  padding: 6px 16px;\n  border-radius: 24px;\n  font-size: 12px;\n}\n.m-5 {\n  margin: 5px;\n}\n.p0 {\n  padding: 0;\n}\n.pointer {\n  cursor: pointer;\n}\n.products {\n  padding: 15px;\n  max-width: 20%;\n}\n.products .row {\n  height: 80px;\n  margin-bottom: 15px;\n  display: flex;\n  align-items: stretch;\n  background-color: #fff;\n  border-radius: 15px;\n}\n.products .row .image {\n  width: 120px;\n  height: 80px;\n  padding: 5px;\n  display: flex;\n  align-items: center;\n}\n.products .row .image img {\n  width: 100%;\n}\n.products .row .type {\n  display: flex;\n  align-items: center;\n  flex-grow: 2;\n  justify-content: center;\n  padding: 15px;\n  border-left: #ddd solid 1px;\n}\n.products .row .account {\n  display: flex;\n  flex-grow: 3;\n  flex-direction: column;\n  justify-content: center;\n  padding: 15px;\n  border-left: #ddd solid 1px;\n}\n.app_customer_layout {\n  padding: 15px 20px;\n}\n.form_group_modal {\n  width: 100%;\n}\n.form_group_modal textarea {\n  width: 100%;\n}\n.image-modal {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  z-index: 9999;\n  display: flex;\n  flex-flow: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  cursor: pointer;\n}\n.image-modal img {\n  width: 100%;\n  height: auto;\n}\n.image-modal p {\n  font-size: 14px;\n  background-color: #fff;\n  border-radius: 6px;\n  margin-bottom: 10px;\n  color: #3091b2;\n  padding: 10px 20px;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
